import { AnyAction, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { convertToAdvertisementAssetFromFileResult } from 'views/Common/typesUtils';
import { ACCESS_MODE,
	Advertisement,
	AdvertisementAsset,
	AdvertisementAssetType,
	BoxLayoutProperties,
	Client,
	DeviceType,
	FileResult,
	Template, } from '@horasys/bellplus/common/types'
import { SEND_MESSAGE } from './errorHandlingSlice';
import { SET_PROGRESS } from './progressSlice';
import { advertisementDetailsbyId, createAd, deleteAdvertisementDetailsById, deleteAsset, getAdvertisementData, updateAd } from 'services/advertising.service';
import { TablePaginationResult } from 'Stores/common';
import { ADD_TEMPLATE, getAllTemplateDetailsByDeviceType } from './templateSlice';
import history from '../../router/history';
const emptyDeviceType: DeviceType = {
	id: 0,
	deviceType: '',
	width: 0,
	height: 0,
	qrScannerEnabled: false,
};
const emptyAdvertisement: Advertisement = {
	id: 0,
	name: '',
	client: { name: '', companyName: '' } as Client,
	template: { name: '' } as Template,
	deviceType: emptyDeviceType,
	templateAssets: [],
	duration: 0,
	noOfSlotsRequired: 0,
	status: '',
};
export interface AdvertisementState {
	list: Array<any>;
	mode: ACCESS_MODE;
	selectedId: number;
	totalElements: number;
	advertisement: Advertisement;
	clientAdvertisements: Array<Advertisement>;
}
const initialState: AdvertisementState = {
	list: [],
	mode: 'CREATE',
	selectedId: 0,
	totalElements: 0,
	advertisement: emptyAdvertisement,
	clientAdvertisements: [],
};

const advertisementSlice = createSlice({
  name:'advertisement',
  initialState,
  reducers:{
    GET_ADVERTISEMENT_DATA_LIST:(state, action:PayloadAction<any>):AdvertisementState=>{
        return {
            ...state,
            list: action.payload.list,
            totalElements: action.payload.totalElements,
        };
    },
    GET_ADVERTISEMENT_DATA_LIST_BY_CLIENT_ID:(state, action:PayloadAction<any>):AdvertisementState=>{
        return {
            ...state,
            clientAdvertisements: action.payload,
        };
    },
    DELETE_ADVERTISEMENT_ASSET:(state, action:PayloadAction<any>):AdvertisementState=>{
        return {
            ...state,
            advertisement: {
                ...state.advertisement,
                templateAssets: [
                    ...getUpdatedTemplateAssets(
                        state.advertisement.templateAssets,
                        action.payload,
                    ),
                ],
            },
        };
    },
    ADVERTISEMENT_ASSET_UPLOAD_COMPLETE:(state, action:PayloadAction<any>):AdvertisementState=>{
        return {
            ...state,
            advertisement: {
                ...state.advertisement,
                templateAssets: [
                    ...handleAdvertisementAssetUploaded(
                        state.advertisement.templateAssets,
                        action.payload.fileResult,
                        action.payload.advertisementAsset,
                        action.payload.type,
                        action.payload.index,
                    ),
                ],
            },
        };
    },
    UPDATE_ADVERTISEMENT_MODE:(state, action:PayloadAction<any>):AdvertisementState=>{
        if (action.payload.mode !== 'CREATE') {
            return {
                ...state,
                mode: action.payload.mode,
                selectedId: action.payload.selectedId,
            };
        } else {
            return {
                ...state,
                advertisement: emptyAdvertisement,
                mode: action.payload.mode,
            };
        }
    },
    GET_ADVERTISEMENT_BY_ID:(state, action:PayloadAction<any>):AdvertisementState=>{
        return {
            ...state,
            advertisement: {
                ...action.payload,
            },
        };
    },
    RESET_ADVERTISEMENT_FORM:(state, action:PayloadAction<any>):AdvertisementState=>{
        return {
            ...state,
            advertisement: {
                ...emptyAdvertisement,
            },
        };
    },
    GENERATE_ADVERTISEMENT_ASSET:(state, action:PayloadAction<any>):AdvertisementState=>{
        return {
            ...state,
            advertisement: {
                ...state.advertisement,
                templateAssets: generateAdvertisementAssets(action.payload),
            },
        };
    },
    UPDATE_ADVERTISEMENT_FORM:(state, action:PayloadAction<any>):AdvertisementState=>{
        return {
            ...state,
            advertisement: {
                ...state.advertisement,
                ...action.payload,
            },
        };
    }
  }
})

export const { GET_ADVERTISEMENT_DATA_LIST ,GET_ADVERTISEMENT_DATA_LIST_BY_CLIENT_ID,DELETE_ADVERTISEMENT_ASSET,ADVERTISEMENT_ASSET_UPLOAD_COMPLETE,UPDATE_ADVERTISEMENT_MODE,GET_ADVERTISEMENT_BY_ID,RESET_ADVERTISEMENT_FORM, GENERATE_ADVERTISEMENT_ASSET,UPDATE_ADVERTISEMENT_FORM} = advertisementSlice.actions
export default advertisementSlice.reducer



const resetAdvertisementAsset = (
	advertisementAsset: AdvertisementAsset,
): AdvertisementAsset => {
	const resetedAdvertisementAsset = { ...advertisementAsset };
	resetedAdvertisementAsset.visible = false;
	resetedAdvertisementAsset.progress = 0;
	resetedAdvertisementAsset.originalFileName = '';
	resetedAdvertisementAsset.uploadstatus = '';
	resetedAdvertisementAsset.url = '';
	resetedAdvertisementAsset.duration = 0;
	resetedAdvertisementAsset.id = 0;
	return resetedAdvertisementAsset;
};
const getUpdatedTemplateAssets = (
	advertisementAssets: Array<AdvertisementAsset>,
	delAdvertisementAsset: AdvertisementAsset,
): Array<AdvertisementAsset> => {
	let updatedAdvertisementAssets: Array<AdvertisementAsset> = [];
	const updatedAdvertisementAsset: AdvertisementAsset = resetAdvertisementAsset(
		delAdvertisementAsset,
	);

	switch (delAdvertisementAsset.type) {
		case 'video': {
			updatedAdvertisementAssets = advertisementAssets.map(
				(advertisementAsset: AdvertisementAsset) => {
					if (
						advertisementAsset.templateAsset &&
						delAdvertisementAsset.templateAsset
					) {
						if (
							advertisementAsset.templateAsset.id ===
							delAdvertisementAsset.templateAsset.id
						) {
							if (delAdvertisementAsset.thumbnailAsset) {
								updatedAdvertisementAsset.thumbnailAsset =
									delAdvertisementAsset?.thumbnailAsset;
							}
							if (delAdvertisementAsset.bufferAsset) {
								updatedAdvertisementAsset.bufferAsset =
									delAdvertisementAsset?.bufferAsset;
							}
							return updatedAdvertisementAsset;
						} else {
							return advertisementAsset;
						}
					} else {
						return advertisementAsset;
					}
				},
			);
			return updatedAdvertisementAssets;
		}
		case 'image': {
			updatedAdvertisementAssets = advertisementAssets.map(
				(advertisementAsset: AdvertisementAsset) => {
					if (
						advertisementAsset.templateAsset &&
						delAdvertisementAsset.templateAsset
					) {
						if (
							advertisementAsset.templateAsset.id ===
							delAdvertisementAsset.templateAsset.id
						) {
							return updatedAdvertisementAsset;
						} else {
							return advertisementAsset;
						}
					} else {
						return advertisementAsset;
					}
				},
			);
			return updatedAdvertisementAssets;
		}

		case 'bufferimage':
		case 'thumbnail': {
			updatedAdvertisementAssets = advertisementAssets.map(
				(advertisementAsset: AdvertisementAsset) => {
					if (advertisementAsset.templateAsset) {
						if (
							advertisementAsset.templateAsset.id ===
							delAdvertisementAsset.parentAssetId
						) {
							if (delAdvertisementAsset.type === 'bufferimage') {
								advertisementAsset.bufferAsset = updatedAdvertisementAsset;
							} else if (delAdvertisementAsset.type === 'thumbnail') {
								advertisementAsset.thumbnailAsset = updatedAdvertisementAsset;
							}
							return advertisementAsset;
						} else {
							return advertisementAsset;
						}
					} else {
						return advertisementAsset;
					}
				},
			);
			return updatedAdvertisementAssets;
		}

		case 'multipleImages': {
			const parentAdvertisementAssets: Array<AdvertisementAsset> = advertisementAssets.filter(
				(advertisementAsset: AdvertisementAsset) => {
					if (advertisementAsset.templateAsset) {
						return (
							advertisementAsset.templateAsset.id ===
							delAdvertisementAsset.parentAssetId
						);
					}
					return false;
				},
			);

			if (parentAdvertisementAssets && parentAdvertisementAssets.length) {
				if (parentAdvertisementAssets[0].children) {
					const updatedChildren: Array<AdvertisementAsset> = parentAdvertisementAssets[0].children.filter(
						(multipleImageAdvertisementAsset: AdvertisementAsset) => {
							return (
								multipleImageAdvertisementAsset.id !==
								delAdvertisementAsset.id
							);
						},
					);
					parentAdvertisementAssets[0].children = [];
					parentAdvertisementAssets[0].children = [...updatedChildren];
					if (
						parentAdvertisementAssets[0].templateAsset &&
						parentAdvertisementAssets[0].templateAsset?.multipleImageCount >
						parentAdvertisementAssets[0].children.length
					)
						handleAddImage(parentAdvertisementAssets[0]);
				}

				updatedAdvertisementAssets = advertisementAssets.map(
					(advertisementAsset: AdvertisementAsset) => {
						if (
							advertisementAsset.templateAsset &&
							parentAdvertisementAssets[0].templateAsset
						) {
							if (
								advertisementAsset.templateAsset.id ===
								parentAdvertisementAssets[0].templateAsset.id
							) {
								return parentAdvertisementAssets[0];
							}
						}
						return advertisementAsset;
					},
				);
				return updatedAdvertisementAssets;
			}
			return advertisementAssets;
		}

		default:
			return advertisementAssets;
	}
};

export const handleAddImage = (advertisementAsset: AdvertisementAsset): AdvertisementAsset => {
	if (advertisementAsset.templateAsset) {
		const newAssetObj: AdvertisementAsset = { ...advertisementAsset };
		const childrenAsset: AdvertisementAsset = {} as AdvertisementAsset;
		childrenAsset.type = 'multipleImages';
		childrenAsset.originalFileName = '';
		childrenAsset.uploadstatus = '';
		childrenAsset.url = '';
		childrenAsset.duration = 0;
		childrenAsset.id = 0;
		childrenAsset.parentAssetId = advertisementAsset.templateAsset.id;

		if (newAssetObj.children) {
			newAssetObj.children.push(childrenAsset);
		} else {
			newAssetObj.children = [];
			newAssetObj.children.push(childrenAsset);
		}
		return newAssetObj;
	}
	return advertisementAsset;
};
const generateAdvertisementAssets = (template: Template) => {
	const advertisementAssets: Array<AdvertisementAsset> = [];
	template.assets.forEach((asset: BoxLayoutProperties) => {
		const advertisementAsset: AdvertisementAsset = {} as AdvertisementAsset;
		advertisementAsset.type = asset.type;
		advertisementAsset.isPrimary = asset.isPrimary;
		advertisementAsset.visible = false;
		advertisementAsset.progress = 0;
		advertisementAsset.originalFileName = '';
		advertisementAsset.uploadstatus = '';
		advertisementAsset.url = '';
		advertisementAsset.duration = 0;
		advertisementAsset.id = 0;
		advertisementAsset.templateAsset = asset;

		advertisementAssets.push(advertisementAsset);
		if (advertisementAsset.type === 'video') {
			const thumbnailAsset: AdvertisementAsset = {} as AdvertisementAsset;
			thumbnailAsset.type = 'thumbnail';
			thumbnailAsset.originalFileName = '';
			thumbnailAsset.uploadstatus = '';
			thumbnailAsset.url = '';
			thumbnailAsset.duration = 0;
			thumbnailAsset.id = 0;
			thumbnailAsset.parentAssetId = asset.id;

			const bufferImage: AdvertisementAsset = {} as AdvertisementAsset;
			bufferImage.type = 'bufferimage';
			bufferImage.originalFileName = '';
			bufferImage.uploadstatus = '';
			bufferImage.url = '';
			bufferImage.duration = 0;
			bufferImage.id = 0;
			bufferImage.parentAssetId = asset.id;

			advertisementAsset.thumbnailAsset = thumbnailAsset;
			advertisementAsset.bufferAsset = bufferImage;
		} else if (advertisementAsset.type === 'multipleImages') {
			const childrenAsset: AdvertisementAsset = {} as AdvertisementAsset;
			childrenAsset.type = 'multipleImages';
			childrenAsset.originalFileName = '';
			childrenAsset.uploadstatus = '';
			childrenAsset.url = '';
			childrenAsset.duration = 0;
			childrenAsset.id = 0;
			childrenAsset.parentAssetId = asset.id;

			advertisementAsset.children = [];
			advertisementAsset.children.push(childrenAsset);
		}
	});
	return [...advertisementAssets];
};

const handleAdvertisementAssetUploaded = (
	templateAssets: Array<AdvertisementAsset>,
	fileResult: FileResult,
	advertisementAsset: AdvertisementAsset,
	type: AdvertisementAssetType,
	selectedIndex: number,
) => {
	let newAssetObj: AdvertisementAsset = { ...advertisementAsset };
	switch (type) {
		case 'video':
		case 'image':
			newAssetObj.id = fileResult.id;
			newAssetObj.duration = fileResult.duration;
			newAssetObj.originalFileName = fileResult.fileName;
			newAssetObj.url = fileResult.url;
			newAssetObj.uploadstatus = fileResult.uploadStatus;
			newAssetObj.source = fileResult.source;
			break;
		case 'thumbnail':
			newAssetObj.thumbnailAsset = {} as AdvertisementAsset;
			newAssetObj.thumbnailAsset.id = fileResult.id;
			newAssetObj.thumbnailAsset.duration = fileResult.duration;
			newAssetObj.thumbnailAsset.originalFileName = fileResult.fileName;
			newAssetObj.thumbnailAsset.url = fileResult.url;
			newAssetObj.thumbnailAsset.uploadstatus = fileResult.uploadStatus;
			newAssetObj.thumbnailAsset.type = 'thumbnail';
			newAssetObj.thumbnailAsset.parentAssetId =
				advertisementAsset.templateAsset?.id;
			newAssetObj.thumbnailAsset.source = fileResult.source;
			break;
		case 'bufferimage':
			newAssetObj.bufferAsset = {} as AdvertisementAsset;
			newAssetObj.bufferAsset.id = fileResult.id;
			newAssetObj.bufferAsset.duration = fileResult.duration;
			newAssetObj.bufferAsset.originalFileName = fileResult.fileName;
			newAssetObj.bufferAsset.url = fileResult.url;
			newAssetObj.bufferAsset.uploadstatus = fileResult.uploadStatus;
			newAssetObj.bufferAsset.type = 'bufferimage';
			newAssetObj.bufferAsset.parentAssetId = advertisementAsset.templateAsset?.id;
			newAssetObj.bufferAsset.source = fileResult.source;
			break;
		case 'multipleImages':
			{
				const newChildren = newAssetObj.children?.map(
					(childAdvertisementAsset: AdvertisementAsset, index: number) => {
						if (selectedIndex === index) {
							return convertToAdvertisementAssetFromFileResult(
								fileResult,
								childAdvertisementAsset,
							);
						} else {
							return childAdvertisementAsset;
						}
					},
				);
				if (newChildren) {
					newAssetObj.children = [...newChildren];
					if (
						newAssetObj.templateAsset &&
						newAssetObj.templateAsset?.multipleImageCount
					)
						if (
							newAssetObj.templateAsset?.multipleImageCount >
							newAssetObj.children.length
						)
							newAssetObj = handleAddImage(newAssetObj);
				}
			}
			break;
		default:
			break;
	}
	const updatedAdAssets: Array<AdvertisementAsset> = templateAssets.map(
		(asset: AdvertisementAsset) => {
			if (asset.templateAsset && newAssetObj.templateAsset) {
				if (asset.templateAsset.id === newAssetObj.templateAsset.id) {
					return newAssetObj;
				} else {
					return asset;
				}
			} else {
				return asset;
			}
		},
	);

	return [...updatedAdAssets];
};
export const delTemplateAssetDetails = (
	advertisementAsset: AdvertisementAsset,
	mode: ACCESS_MODE,
):any => async (dispatch: any) => {
	try {
		dispatch(SET_PROGRESS(true));
		if (
			mode === 'CREATE' &&
			advertisementAsset.source &&
			advertisementAsset.source === 'file-system'
		) {
			await deleteAsset(advertisementAsset.id);
		}
		dispatch(deleteTemplateAdvertisement(advertisementAsset));
		dispatch(SET_PROGRESS(false));
	} catch (error:any) {
		dispatch(SEND_MESSAGE({message:error, type:'error'}));
		dispatch(SET_PROGRESS(false));
	}
};

export const deleteTemplateAdvertisement = (
	advertisementAsset: AdvertisementAsset,

)=> async (dispatch: any) => {
	try {
		dispatch(DELETE_ADVERTISEMENT_ASSET(advertisementAsset));

	} catch (error) {
		dispatch(SEND_MESSAGE({message:error, type:'error'}));

	}
};

export const handleAdvertisementAssetComplete = (
	fileResult: FileResult,
	advertisementAsset: AdvertisementAsset,
	type: AdvertisementAssetType,
	index = 0,
)=> async (dispatch: any) => {
	try {
		dispatch(ADVERTISEMENT_ASSET_UPLOAD_COMPLETE({fileResult: fileResult,
			advertisementAsset: advertisementAsset,
			type: type,
			index: index,}));

	} catch (error:any) {
		dispatch(SEND_MESSAGE({message:error, type:'error'}));

	}
};

export const deleteAdvertisementById = (advertisementId: number):any => async (
	dispatch: any,
) => {
	try {
		dispatch(SET_PROGRESS(true));
		await deleteAdvertisementDetailsById(advertisementId);
		dispatch(SET_PROGRESS(false));
		dispatch(SEND_MESSAGE({message:'DELETED SUCCESSFULLY', type:'success'}));
		dispatch(getAdvertisements());
	} catch (error:any) {
		dispatch(SEND_MESSAGE({message:error, type:'error'}));
		dispatch(SET_PROGRESS(false));
	}
};
export const getAdvertisements = (
	pageIndex = 0,
	pageSize = 10,
	filterRequestObject: any = [],
	sortRequestObject: any = [],
):any => async (dispatch: any) => {
	try {
		const advertisements = await getAdvertisementData(
			pageIndex,
			pageSize,
			filterRequestObject,
			sortRequestObject,
		);
		dispatch(GET_ADVERTISEMENT_DATA_LIST(advertisements));
	} catch (error:any) {
		dispatch(SEND_MESSAGE({message:error, type:'error'}));
	}
};

export const updateAdvertisementMode = (selectedId: number, mode:ACCESS_MODE) => async (dispatch: any) => {
	try {
    dispatch(UPDATE_ADVERTISEMENT_MODE({selectedId, mode}));
	} catch (error:any) {
    dispatch(SEND_MESSAGE({ message: error , type:'error'}));
	}
};


export const resetAdvertisementForm = () => async (dispatch: any) => {
	try {
    dispatch(RESET_ADVERTISEMENT_FORM(null))
	} catch (error:any) {
    dispatch(SEND_MESSAGE({ message: error , type:'error'}));
	}
};

export const getAdvertisementDetailsById =  (advertisementId: number):any => async (
	dispatch: any,
) => {
	try {
		dispatch(SET_PROGRESS(true));
		const advertisement: Advertisement = await advertisementDetailsbyId(
			advertisementId,
		);
		if (advertisement.deviceType && advertisement.deviceType.id) {
			dispatch(getAllTemplateDetailsByDeviceType(advertisement.deviceType.id));
		}
		const template: Template = {} as Template;
		template.id = advertisement.template.id ? advertisement.template.id : 0;
		template.name = advertisement.template.name ? advertisement.template.name : '';
		dispatch(ADD_TEMPLATE(template));
		dispatch(GET_ADVERTISEMENT_BY_ID(advertisement));
		dispatch(SET_PROGRESS(false));
	} catch (error:any) {
		dispatch(SEND_MESSAGE({message:error, type:'error'}));
		dispatch(SET_PROGRESS(false));
	}
};

export const createAdvertisementDetails = (advertisement: Advertisement):any => async (
	dispatch: any,
) => {
	try {
		dispatch(SET_PROGRESS(true));
		await createAd(advertisement);
		dispatch(SET_PROGRESS(false));
		dispatch(SEND_MESSAGE({message:'CREATED SUCCESSFULLY', type:'success'}));
		setTimeout(() => {
			history.back();
		}, 2000);
	} catch (error:any) {
		dispatch(SEND_MESSAGE({message:error, type:'error'}));
		dispatch(SET_PROGRESS(false));
	}
};
export const updateAdvertisementDetails = (advertisement: Advertisement):any => async (
	dispatch: any,
) => {
	try {
		dispatch(SET_PROGRESS(true));
		await updateAd(advertisement.id, advertisement);
		dispatch(SET_PROGRESS(false));
		dispatch(SEND_MESSAGE({message:'CREATED SUCCESSFULLY', type:'success'}));
		setTimeout(() => {
			history.back();
		}, 2000);
	} catch (error:any) {
		dispatch(SEND_MESSAGE({message:error, type:'error'}));
		dispatch(SET_PROGRESS(false));
	}
};
